import ContainerSupportRepository from "@/repositories/ContainerSupportRepository";
import makeStore from "@/storages/Base/Storage";

let store = makeStore('container_support', ContainerSupportRepository)

export default {
    ...store,
    actions: {
        ...store.actions,
        async listAll({commit}, params) {
            commit('setLoading', true)
            await ContainerSupportRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', response.data)
            })
            commit('setLoading', false)
        }
    }
}
